<template>
	<v-flex :class="classes">
		<v-menu
			ref="menu"
			v-model="menuTime"
			:close-on-content-click="false"
			:nudge-right="40"
			:return-value.sync="time"
			lazy
			transition="scale-transition"
			offset-y
			full-width
			max-width="290px"
			min-width="290px"
		>
			<template v-slot:activator="{ on }">
				<v-text-field
					:value="nValue"
          :label="label"
          :placeholder="placeholder"
					:color="color"
          :outline="outline"
          :box="box"
          :required="required"
          :rules="rules"
					:readonly="readonly && $route.params.id != 'new'"
					:disabled="disabled && $route.params.id != 'new'"
          v-on="on"
				></v-text-field>
			</template>
			<v-time-picker
				v-if="menuTime"
				v-model="time"
				full-width
				format="24hr"
				color="primary"
				@click:minute="save(time)"
			></v-time-picker>
		</v-menu>
	</v-flex>
</template>
<script>
import { propsMixin } from '@/mixins/FieldsProps'

export default {
	mixins: [propsMixin],
	data () {
		return {
			time: null,
			menuTime: false,
			nValue: ''
		}
	},
	created() {
		if (this.value) this.nValue = this.value
	},
	methods: {
		save (date) {
			this.$refs.menu.save(date)
			if (this.sensitive) {
				date = this.sensitive(date)
			}
			this.nValue = date
			this.$emit('input', date)
		}
	}
}
</script>